import React from "react"

import { Helmet } from "react-helmet"

import * as ReactDOMServer from "react-dom/server"

interface IPodZalogDefault {
  url?: string
  shortTitle?: string
  description?: string
  titleH1?: string
  FaqItem?: JSX.Element[][]
}

export const PodZalogDefault = ({
  url,
  shortTitle,
  description,
  titleH1,
  FaqItem,
}: IPodZalogDefault) => (
  <Helmet>
    <script type="application/ld+json">
      {JSON.stringify([
        {
          "@context": "https://schema.org",
          "@type": "BankOrCreditUnion",
          name: "Совкомбанк",
          image: "https://sovcombank.ru/logo.png",
          "@id": "https://sovcombank.ru",
          url: "https://sovcombank.ru/",
          telephone: "8 (800) 700-66-96",
          priceRange: "50 000 - 30 000 000",
          address: {
            "@type": "PostalAddress",
            streetAddress: "Краснопресненская набережная, 14 стр 1",
            addressLocality: "Москва",
            postalCode: "123100",
            addressCountry: "RU",
          },
          openingHoursSpecification: {
            "@type": "OpeningHoursSpecification",
            dayOfWeek: [
              "Monday",
              "Tuesday",
              "Wednesday",
              "Thursday",
              "Friday",
              "Saturday",
              "Sunday",
            ],
            opens: "00:00",
            closes: "23:59",
          },
          sameAs: [
            "https://ru.wikipedia.org/wiki/Совкомбанк",
            "https://sovcombank.ru",
            "https://www.youtube.com/channel/UCptG0e45r5jZexlXJ_obmvA",
          ],
        },
        {
          "@context": "https://schema.org/",
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "Главная",
              item: "https://sovcombank.ru/",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "💰 Кредиты",
              item: "https://sovcombank.ru/credits",
            },
            {
              "@type": "ListItem",
              position: 3,
              name: "💵 Наличными",
              item: "https://sovcombank.ru/credits/cash",
            },
            {
              "@type": "ListItem",
              position: 4,
              name: `${shortTitle}`,
              item: `${url}`,
            },
          ],
        },
        {
          "@context": "https://schema.org/",
          "@type": "Product",
          name: `${titleH1}`,
          image: "https://sovcombank.ru/logo.png",
          description: `${description}`,
          brand: {
            "@type": "Brand",
            name: "Совкомбанк",
          },
          offers: {
            "@type": "AggregateOffer",
            url: `${url}`,
            priceCurrency: "RUB",
            lowPrice: "200000",
            highPrice: "30000000",
          },
          aggregateRating: {
            "@type": "AggregateRating",
            ratingValue: "4,9",
            bestRating: "5",
            worstRating: "1",
            ratingCount: "10634",
          },
        },
      ])}
    </script>
    <script type="application/ld+json">
      {JSON.stringify([
        {
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: FaqItem?.map(([question, answer]: JSX.Element[]) => ({
            "@type": "Question",
            name: ReactDOMServer.renderToString(question),
            acceptedAnswer: {
              "@type": "Answer",
              text: ReactDOMServer.renderToString(answer),
            },
          })),
        },
      ])}
    </script>
  </Helmet>
)
